import type { BulkArgs, DiscrepancyArgs, SaveFilterArgs } from '../api/pricingApi'
import { normalizeGuid } from './format'
import type { CommandAttempt, PricingOverviewVm } from './types'

/**
 * Сборка аргументов команд и запросов из vm (чистые функции, F05): binding
 * только вызывает endpoint, а что именно уходит на сервер, проверяют тесты.
 * Ключи попытки приходят снаружи — их создаёт намерение, а не эта функция.
 */

/** Сохранить личную пару видов цен. `null` — форма ещё не готова. */
export function buildSaveFilterArgs(vm: PricingOverviewVm, attempt: CommandAttempt): SaveFilterArgs | null {
  const first = normalizeGuid(vm.filter.draft.first)
  const second = normalizeGuid(vm.filter.draft.second)
  if (vm.configurationVersion === null || first === null || second === null || !vm.filter.canSave) return null
  return { resourceId: vm.resourceId, configurationVersion: vm.configurationVersion, first, second, ...attempt }
}

/** Остатки/цены по набору товаров: ревизия входит в ключ кэша. */
export function buildBulkArgs(vm: PricingOverviewVm, keys: readonly string[]): BulkArgs | null {
  if (vm.configurationVersion === null || keys.length === 0) return null
  return { resourceId: vm.resourceId, refKeys: keys, configurationVersion: vm.configurationVersion }
}

/** Аргументы сверки: показанная пара (несохранённая) или личная пара сервера. */
export function buildDiscrepancyArgs(resourceId: string, comparing: PricingOverviewVm['comparing']): DiscrepancyArgs {
  if (comparing === null) return { resourceId, first: null, second: null }
  return { resourceId, first: normalizeGuid(comparing.first), second: normalizeGuid(comparing.second) }
}
